module.exports = __webpack_public_path__ + "img/male-q.1efad1cf.jpg";